import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRotate = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M5.99072 9L6.99072 11L5.49072 12.5",
		stroke: "#8C94AA",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.77295 10.8701C5.1509 10.6757 3.78437 10.2759 2.93155 9.74611C2.07874 9.21638 1.79869 8.59344 2.14431 7.99498C2.48994 7.39652 3.43731 6.864 4.80743 6.49801C6.17755 6.13203 7.87554 5.95793 9.5806 6.00861C11.2857 6.0593 12.8797 6.33125 14.0616 6.77309C15.2434 7.21493 15.9313 7.79606 15.9951 8.40669C16.059 9.01732 15.4944 9.61516 14.4081 10.0873C13.3219 10.5594 11.7891 10.873 10.0993 10.969",
		stroke: "#8C94AA",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgRotate);
export default ForwardRef;
